$shm_hitalama_text_table_body $mol_grid_table
	render_visible_only false
